import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { getAllArticles, getAllTagsAndAuthors } from "../../Helpers/ArticleHelpers";
import { Container, Divider, Grid, Card, Typography, Chip, CardContent, Hidden } from "@material-ui/core";
import ArticlesGridList from "./ArticlesGridList";
import FeaturedArticles from "./FeaturedArticles";
import SlideShow from "./Slideshow";
import { Redirect } from "react-router";
import Loading from "../Loading/Loading";

const styles = theme => ({
    section: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
        '&:first-child': {
            marginTop: 0
        },
        '&:last-child': {
            marginBottom: 0
        }
    },
    divider: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4)
    }
});

class Home extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            articles: null,
            redirectURL: null
        };

        this.getArticles();
    }
    getArticles = async () => {
        let articles;
        articles = await getAllArticles(null, 6, true);
        this.setState({ articles });
    }

    render() {
        const { classes } = this.props;
        if (this.state.articles) {
            return (
                <div className={classes.root}>
                    <Container>
                        <Hidden smDown>
                            <section className={classes.section}>
                                <SlideShow articles={this.state.articles.slice(0, 4)} />
                                {/* <ArticlesGridList articles={this.state.articles.slice(0, 4)} /> */}
                            </section>
                            <Divider className={classes.divider} />
                        </Hidden>
                        <section>
                            <Grid container spacing={8}>
                                <Grid item sm={8} xs={12}>
                                    <FeaturedArticles articles={this.state.articles} />
                                </Grid>
                                <Grid item sm={4} xs={12}>
                                    <FilterCards />
                                </Grid>
                            </Grid>
                        </section>
                    </Container>
                </div>
            );
        } else {
            return (<Loading />)
        }
    }
}

class FilterCards extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            tags: null,
            authors: null,
            redirectURL: null
        }
        this.getData()
    }
    getData = async () => {
        const data = await getAllTagsAndAuthors()
        this.setState({ tags: data.tags, authors: data.authors })
    }

    handleTagClick = (tag) => {
        this.setState({ redirectURL: `/articles?tag=${tag}` })
    }

    handleAuthorClick = (authorID) => {
        this.setState({ redirectURL: `/articles?author=${authorID}` })
    }

    returnRedirect = () => {
        if (this.state.redirectURL) {
            return (
                <Redirect to={`${this.state.redirectURL}`} />
            )
        }
    }

    render() {
        return (
            <div>
                {this.returnRedirect()}
                <Card>
                    <CardContent>
                        <Typography variant='h5' component='h2' style={{ marginBottom: 10 }}>
                            Articles by tag
                        </Typography>
                        <div className="tags">
                            {this.state.tags && this.state.tags.map(t => (
                                <Chip
                                    key={t}
                                    label={t}
                                    style={{ marginRight: 10, marginBottom: 10, cursor: 'pointer' }}
                                    variant="default"
                                    onClick={() => this.handleTagClick(t)}
                                    color="primary" />
                            ))}
                        </div>
                    </CardContent>
                </Card>
                <Card style={{ marginTop: 24 }}>
                    <CardContent>
                        <Typography variant='h5' component='h2' style={{ marginBottom: 10 }}>
                            Articles by author
                        </Typography>
                        <div className="tags">
                            {this.state.authors && this.state.authors.map(a => (
                                <Chip
                                    key={a.id}
                                    label={a.name}
                                    style={{ marginRight: 10, marginBottom: 10, cursor: 'pointer' }}
                                    variant="default"
                                    onClick={() => this.handleAuthorClick(a.name)}
                                    color="primary" />
                            ))}
                        </div>
                    </CardContent>
                </Card>
            </div>
        )
    }
}

export default withStyles(styles)(Home);
